<div>
	<div
		class="card-long"
		[ngClass]="{
			'card-long-2': creative.adHeadline || creative.isVideoCreative,
			'card-long-social': creative.isSocial
		}"
	>
		<div
			class="card-long-bg"
			[ngClass]="{ 'card-long-bg-2': creative.isSocial }"
			[ngStyle]="{ 'padding-top': creative.adHeadline ? '0' : '0px' }"
		>
			<div *ngIf="!creative.isVideoCreative &&  (!creative.adHeadline && !creative.description) && !creative.isSocial && !creative.isRadio">
				<div class="creative-name-arrows-div creative-name-arrows-div-display">
					<div class="leftRs cursorPointer" [ngClass]="{ arrows_disabled: creativesNum == 1 }">
						<img src="../../../../../assets/creative-assets/arrow-left-r7.svg" (click)="navigateLeft()" />
					</div>
					<div>
						<h5 class="ellipse creative-card-name" [title]="creative?.creativeName">
							{{ creative?.creativeName }}
						</h5>
					</div>
					<div class="rightRs cursorPointer" [ngClass]="{ arrows_disabled: creativesNum == 1 }">
						<img src="../../../../../assets/creative-assets/arrow-right-r7.svg" (click)="navigateRight()" />
					</div>
				</div>
				<div class="card-long-img">
					<div
						*ngIf="creative?.creativeThumbnail"
						class="creative-thumbnail"
						(click)="openModal()"
						[ngStyle]="{
							background: 'url(' + creative?.creativeThumbnail + ') no-repeat center center / contain',
							'background-size': getCreativeSize(creative.creativeThumbnail)
						}"
					></div>
				</div>
				<div class="badge-display">
					<p class="pills primary-color-bg" *ngIf="creative?.isIAB && !creative?.isNative">IAB Display</p>
					<p class="pills primary-color-bg" *ngIf="creative?.isNative && !creative?.isIAB">Native</p>
					<p class="pills primary-color-bg" *ngIf="creative?.isIAB && creative?.isNative">IAB Display and Native</p>
				</div>
			</div>
			<div *ngIf="creative.isVideoCreative && !creative.isSocial && !creative.isRadio" class="creative-video">
				<div class="creative-name-arrows-div creative-name-arrows-div-video">
					<div class="leftRs cursorPointer" [ngClass]="{ arrows_disabled: creativesNum == 1 }">
						<img src="../../../../../assets/creative-assets/arrow-left-r7.svg" (click)="navigateLeft()" />
					</div>
					<div>
						<h5 class="ellipse creative-card-name" [title]="creative?.creativeName">
							{{ creative?.creativeName }}
						</h5>
					</div>
					<div class="rightRs cursorPointer" [ngClass]="{ arrows_disabled: creativesNum == 1 }">
						<img src="../../../../../assets/creative-assets/arrow-right-r7.svg" (click)="navigateRight()" />
					</div>
				</div>
				<app-video-player [videoURL]="creative.creativeVideo" [videoButtonsPath]="videoButtonsPath"> </app-video-player>
			</div>
			<div *ngIf="!creative.isVideoCreative && !creative.isSocial && creative.isRadio" class="creative-radio">
				<div class="creative-name-arrows-div creative-name-arrows-div-video">
					<div class="leftRs cursorPointer" [ngClass]="{ arrows_disabled: creativesNum == 1 }">
						<img src="../../../../../assets/creative-assets/arrow-left-r7.svg" (click)="navigateLeft()" />
					</div>
					<div>
						<h5 class="ellipse creative-card-name" [title]="creative?.creativeName">
							{{ creative?.creativeName }}
						</h5>
					</div>
					<div class="rightRs cursorPointer" [ngClass]="{ arrows_disabled: creativesNum == 1 }">
						<img src="../../../../../assets/creative-assets/arrow-right-r7.svg" (click)="navigateRight()" />
					</div>
				</div>
				<div class="audio-icon-block" *ngIf="creative.audioURL !== ''">
					<div class="audio-content">
						<svg width="100" height="76" viewBox="0 0 100 76" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M22.0925 30.7058V30.705L22.0922 30.693L22.0918 30.6704L22.0913 30.6394C22.0907 30.5901 22.0901 30.5139 22.0905 30.4127C22.0914 30.2102 22.0963 29.9078 22.113 29.5197C22.1462 28.743 22.2262 27.6259 22.4133 26.2823C22.7884 23.5892 23.5896 20.0181 25.2851 16.4623C26.9779 12.9121 29.5519 9.39688 33.4711 6.76551C37.3846 4.13805 42.7129 2.34207 50 2.34207C57.2871 2.34207 62.6154 4.13805 66.5289 6.76551C70.4481 9.39688 73.0221 12.9121 74.7149 16.4623C76.4103 20.0181 77.2116 23.5892 77.5867 26.2823C77.7738 27.6259 77.8538 28.743 77.887 29.5197C77.9037 29.9078 77.9086 30.2102 77.9095 30.4127C77.9099 30.5139 77.9093 30.5901 77.9087 30.6394L77.908 30.6797L77.9075 30.7043L77.9075 30.705V30.706L77.8719 31.9108H80.814C90.1257 31.9108 97.6744 39.513 97.6744 48.8908C97.6744 49.5376 98.195 50.0619 98.8372 50.0619C99.4794 50.0619 100 49.5376 100 48.8908C100 38.2195 91.4101 29.5687 80.814 29.5687H80.2165L80.2144 29.5125C80.2131 29.4817 80.2118 29.4505 80.2105 29.4187C80.1745 28.5783 80.0887 27.3854 79.8897 25.957C79.4926 23.1059 78.6405 19.2848 76.8113 15.4485C74.9793 11.6065 72.1572 7.72954 67.8189 4.81678C63.4747 1.90011 57.6839 0 50 0C42.3161 0 36.5253 1.90011 32.1811 4.81678C27.8427 7.72954 25.0207 11.6065 23.1887 15.4485C21.3595 19.2848 20.5074 23.1059 20.1103 25.957C19.9113 27.3854 19.8255 28.5783 19.7895 29.4187C19.7873 29.47 19.7853 29.52 19.7835 29.5687H19.186C8.58988 29.5687 0 38.2195 0 48.8908C0 59.5621 8.58988 68.2129 19.186 68.2129H74.4186C75.0608 68.2129 75.5814 67.6886 75.5814 67.0419C75.5814 66.3951 75.0608 65.8709 74.4186 65.8709H19.186C9.87428 65.8709 2.32558 58.2686 2.32558 48.8908C2.32558 39.513 9.87428 31.9108 19.186 31.9108H22.1281L22.0925 30.7058Z"
								fill="var(--primary-color)"
							/>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M81.1839 44.4196C81.1839 41.2299 83.7513 38.6442 86.9185 38.6442C90.0857 38.6442 92.6532 41.2299 92.6532 44.4196V57.6204C92.6532 60.81 90.0857 63.3957 86.9185 63.3957C83.7513 63.3957 81.1839 60.81 81.1839 57.6204V44.4196ZM90.3276 44.4196V57.6204C90.3276 59.5165 88.8013 61.0536 86.9185 61.0536C85.0357 61.0536 83.5094 59.5165 83.5094 57.6204V44.4196C83.5094 42.5234 85.0357 40.9863 86.9185 40.9863C88.8013 40.9863 90.3276 42.5234 90.3276 44.4196Z"
								fill="var(--primary-color)"
							/>
							<path
								d="M77.9753 54.8006C78.6168 54.8318 79.1116 55.3807 79.0807 56.0267C79.0026 57.6544 79.3277 60.0907 80.4999 62.0751C81.6278 63.9845 83.5565 65.5249 86.9186 65.5249C90.2808 65.5249 92.2095 63.9845 93.3373 62.0751C94.5095 60.0907 94.8346 57.6544 94.7565 56.0267C94.7256 55.3807 95.2205 54.8318 95.8619 54.8006C96.5034 54.7694 97.0484 55.2678 97.0794 55.9138C97.1728 57.8614 96.8037 60.7879 95.336 63.2725C94.0044 65.5267 91.785 67.3739 88.3721 67.7826V73.1898H90.1691C90.8113 73.1898 91.3319 73.7141 91.3319 74.3609C91.3319 75.0076 90.8113 75.5319 90.1691 75.5319H84.3023C83.6601 75.5319 83.1395 75.0076 83.1395 74.3609C83.1395 73.7141 83.6601 73.1898 84.3023 73.1898H86.0465V67.8373C82.3022 67.5784 79.9069 65.6523 78.5012 63.2725C77.0336 60.7879 76.6644 57.8614 76.7578 55.9138C76.7888 55.2678 77.3339 54.7694 77.9753 54.8006Z"
								fill="var(--primary-color)"
							/>
							<path
								d="M76.5432 41.6259C77.1339 41.5662 77.6163 42.0565 77.6163 42.6543C77.6163 43.2521 77.1332 43.7298 76.5442 43.8043C75.7824 43.9006 75.0352 44.0994 74.3229 44.3965C73.2787 44.8321 72.33 45.4705 71.5308 46.2753C70.7317 47.0801 70.0977 48.0356 69.6652 49.0871C69.3702 49.8045 69.1728 50.557 69.0772 51.3243C69.0032 51.9174 68.5289 52.4039 67.9353 52.4039C67.3417 52.4039 66.8549 51.9181 66.9141 51.3233C67.0188 50.2715 67.2761 49.2388 67.6792 48.2587C68.2197 46.9445 69.012 45.7503 70.0108 44.7445C71.0095 43.7386 72.1953 42.9407 73.5002 42.3964C74.4735 41.9904 75.4989 41.7313 76.5432 41.6259Z"
								fill="var(--primary-color)"
							/>
							<path
								d="M77.6163 46.1686C77.6163 45.5701 77.1319 45.0767 76.5442 45.165C75.9586 45.253 75.3846 45.4129 74.8351 45.6421C73.9534 46.0099 73.1523 46.549 72.4774 47.2286C71.8026 47.9082 71.2673 48.7151 70.902 49.6031C70.6745 50.1564 70.5157 50.7345 70.4284 51.3242C70.3407 51.9161 70.8306 52.4039 71.4249 52.4039C72.0192 52.4039 72.4896 51.9135 72.6137 51.3282C72.6785 51.0225 72.771 50.7227 72.8903 50.4325C73.1474 49.8075 73.5242 49.2396 73.9992 48.7612C74.4742 48.2828 75.0381 47.9034 75.6587 47.6445C75.9469 47.5243 76.2446 47.4312 76.5481 47.3659C77.1293 47.2409 77.6163 46.7671 77.6163 46.1686Z"
								fill="var(--primary-color)"
							/>
							<path
								d="M76.6781 48.7172C77.1853 48.5863 77.6163 49.0255 77.6163 49.5528V49.7629C77.6163 50.1742 77.273 50.4946 76.8957 50.652C76.6673 50.7473 76.4597 50.8869 76.2848 51.063C76.11 51.2391 75.9713 51.4482 75.8767 51.6782C75.7204 52.0582 75.4023 52.4039 74.9939 52.4039H74.7853C74.2617 52.4039 73.8255 51.9699 73.9555 51.4591C73.9998 51.2851 74.0563 51.1141 74.1249 50.9475C74.3148 50.4857 74.5932 50.0662 74.9441 49.7128C75.295 49.3594 75.7116 49.079 76.1701 48.8878C76.3356 48.8187 76.5054 48.7618 76.6781 48.7172Z"
								fill="var(--primary-color)"
							/>
						</svg>
						<svg
							style="display: none"
							width="75%"
							height="75%"
							viewBox="0 0 867 678"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<rect width="100%" height="100%" fill="url(#paint0_radial)" />
							<mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="100%" height="100%">
								<rect width="100%" height="100%" fill="#014656" />
							</mask>
							<g mask="url(#mask0)">
								<path
									d="M219.257 382.426C220.112 382.427 220.959 382.257 221.75 381.928C222.54 381.599 223.258 381.116 223.863 380.506C224.468 379.897 224.948 379.174 225.275 378.378C225.602 377.582 225.77 376.729 225.77 375.868V303.724C225.77 301.985 225.083 300.317 223.862 299.087C222.641 297.857 220.984 297.166 219.257 297.166C217.529 297.166 215.873 297.857 214.651 299.087C213.43 300.317 212.744 301.985 212.744 303.724V375.868C212.743 376.729 212.911 377.582 213.238 378.378C213.566 379.174 214.045 379.897 214.65 380.506C215.255 381.116 215.973 381.599 216.764 381.928C217.554 382.257 218.401 382.427 219.257 382.426Z"
									fill="white"
									fill-opacity="0.15"
								/>
								<path
									d="M165.969 224.931C165.113 224.931 164.266 225.1 163.476 225.428C162.685 225.757 161.967 226.239 161.362 226.848C160.757 227.456 160.277 228.177 159.95 228.972C159.623 229.766 159.455 230.618 159.456 231.478V447.522C159.456 449.258 160.142 450.924 161.363 452.151C162.585 453.379 164.241 454.069 165.969 454.069C167.696 454.069 169.352 453.379 170.574 452.151C171.795 450.924 172.481 449.258 172.481 447.522V231.478C172.482 230.618 172.314 229.766 171.987 228.972C171.66 228.177 171.18 227.456 170.575 226.848C169.97 226.239 169.252 225.757 168.462 225.428C167.671 225.1 166.824 224.931 165.969 224.931Z"
									fill="white"
									fill-opacity="0.15"
								/>
								<path
									d="M112.681 562.421C113.536 562.421 114.384 562.252 115.174 561.923C115.964 561.593 116.683 561.111 117.287 560.502C117.892 559.893 118.372 559.17 118.699 558.374C119.026 557.578 119.194 556.725 119.194 555.864V123.136C119.194 121.397 118.508 119.729 117.286 118.499C116.065 117.27 114.408 116.579 112.681 116.579C110.954 116.579 109.297 117.27 108.076 118.499C106.854 119.729 106.168 121.397 106.168 123.136V555.864C106.167 556.725 106.336 557.578 106.663 558.374C106.99 559.17 107.47 559.893 108.074 560.502C108.679 561.111 109.398 561.593 110.188 561.923C110.978 562.252 111.825 562.421 112.681 562.421Z"
									fill="white"
									fill-opacity="0.15"
								/>
								<path
									d="M59.0971 454.069C59.9914 454.069 60.8771 453.9 61.7034 453.572C62.5297 453.243 63.2806 452.76 63.9129 452.152C64.5453 451.544 65.0468 450.823 65.3888 450.028C65.7308 449.234 65.9066 448.382 65.9061 447.522V231.478C65.9061 229.742 65.1887 228.076 63.9118 226.849C62.6349 225.621 60.903 224.931 59.0971 224.931C57.2912 224.931 55.5593 225.621 54.2824 226.849C53.0055 228.076 52.2881 229.742 52.2881 231.478V447.522C52.2876 448.382 52.4633 449.234 52.8053 450.028C53.1473 450.823 53.6489 451.544 54.2812 452.152C54.9136 452.76 55.6644 453.243 56.4908 453.572C57.3171 453.9 58.2028 454.069 59.0971 454.069Z"
									fill="white"
									fill-opacity="0.15"
								/>
								<path
									d="M5.51296 382.426C6.36839 382.427 7.21554 382.257 8.00595 381.928C8.79636 381.599 9.51455 381.116 10.1194 380.506C10.7243 379.897 11.204 379.174 11.5312 378.378C11.8583 377.582 12.0264 376.729 12.0259 375.868V303.724C12.0259 301.985 11.3397 300.317 10.1183 299.087C8.8969 297.857 7.2403 297.166 5.51296 297.166C3.78562 297.166 2.12902 297.857 0.907604 299.087C-0.313813 300.317 -0.999999 301.985 -0.999999 303.724V375.868C-1.0005 376.729 -0.832373 377.582 -0.505242 378.378C-0.178111 379.174 0.301609 379.897 0.906492 380.506C1.51138 381.116 2.22956 381.599 3.01997 381.928C3.81039 382.257 4.65753 382.427 5.51296 382.426Z"
									fill="white"
									fill-opacity="0.15"
								/>
								<path
									d="M272.544 417.952C273.4 417.952 274.247 417.783 275.037 417.455C275.828 417.127 276.546 416.645 277.151 416.038C277.756 415.431 278.235 414.71 278.562 413.916C278.89 413.123 279.058 412.273 279.057 411.414V267.586C279.057 265.852 278.371 264.189 277.15 262.963C275.928 261.737 274.272 261.048 272.544 261.048C270.817 261.048 269.16 261.737 267.939 262.963C266.717 264.189 266.031 265.852 266.031 267.586V411.414C266.031 412.273 266.199 413.123 266.526 413.916C266.853 414.71 267.333 415.431 267.938 416.038C268.543 416.645 269.261 417.127 270.051 417.455C270.842 417.783 271.689 417.952 272.544 417.952Z"
									fill="white"
									fill-opacity="0.15"
								/>
								<path
									d="M326.128 490.186C327.023 490.187 327.908 490.018 328.735 489.689C329.561 489.359 330.312 488.877 330.944 488.268C331.577 487.66 332.078 486.938 332.42 486.142C332.762 485.347 332.938 484.495 332.937 483.635V195.365C332.937 193.628 332.22 191.961 330.943 190.733C329.666 189.504 327.934 188.814 326.128 188.814C324.322 188.814 322.591 189.504 321.314 190.733C320.037 191.961 319.319 193.628 319.319 195.365V483.635C319.319 484.495 319.495 485.347 319.837 486.142C320.179 486.938 320.68 487.66 321.312 488.268C321.945 488.877 322.696 489.359 323.522 489.689C324.348 490.018 325.234 490.187 326.128 490.186Z"
									fill="white"
									fill-opacity="0.15"
								/>
								<path
									d="M379.712 417.952C380.568 417.952 381.415 417.783 382.205 417.455C382.996 417.127 383.714 416.645 384.319 416.038C384.924 415.431 385.403 414.71 385.73 413.916C386.058 413.123 386.226 412.273 386.225 411.414V267.586C386.225 265.852 385.539 264.189 384.318 262.963C383.096 261.737 381.44 261.048 379.712 261.048C377.985 261.048 376.328 261.737 375.107 262.963C373.885 264.189 373.199 265.852 373.199 267.586V411.414C373.199 412.273 373.367 413.123 373.694 413.916C374.021 414.71 374.501 415.431 375.106 416.038C375.711 416.645 376.429 417.127 377.219 417.455C378.01 417.783 378.857 417.952 379.712 417.952Z"
									fill="white"
									fill-opacity="0.15"
								/>
								<path
									d="M433 382.426C433.855 382.427 434.702 382.257 435.493 381.928C436.283 381.599 437.001 381.116 437.606 380.506C438.211 379.897 438.691 379.174 439.018 378.378C439.345 377.582 439.513 376.729 439.513 375.868V303.724C439.513 301.985 438.827 300.317 437.605 299.087C436.384 297.857 434.727 297.166 433 297.166C431.272 297.166 429.616 297.857 428.394 299.087C427.173 300.317 426.487 301.985 426.487 303.724V375.868C426.486 376.729 426.654 377.582 426.982 378.378C427.309 379.174 427.788 379.897 428.393 380.506C428.998 381.116 429.716 381.599 430.507 381.928C431.297 382.257 432.144 382.427 433 382.426Z"
									fill="white"
									fill-opacity="0.15"
								/>
								<path
									d="M646.743 382.426C647.599 382.427 648.446 382.257 649.236 381.928C650.027 381.599 650.745 381.116 651.35 380.506C651.955 379.897 652.435 379.174 652.762 378.378C653.089 377.582 653.257 376.729 653.256 375.868V303.724C653.256 301.985 652.57 300.317 651.349 299.087C650.127 297.857 648.471 297.166 646.743 297.166C645.016 297.166 643.359 297.857 642.138 299.087C640.917 300.317 640.23 301.985 640.23 303.724V375.868C640.23 376.729 640.398 377.582 640.725 378.378C641.052 379.174 641.532 379.897 642.137 380.506C642.742 381.116 643.46 381.599 644.25 381.928C645.041 382.257 645.888 382.427 646.743 382.426Z"
									fill="white"
									fill-opacity="0.15"
								/>
								<path
									d="M700.032 261.048C699.176 261.048 698.329 261.217 697.539 261.545C696.748 261.873 696.03 262.355 695.425 262.962C694.82 263.569 694.34 264.29 694.013 265.084C693.686 265.877 693.518 266.727 693.519 267.586V411.414C693.519 413.148 694.205 414.811 695.426 416.037C696.648 417.263 698.304 417.952 700.032 417.952C701.759 417.952 703.415 417.263 704.637 416.037C705.858 414.811 706.544 413.148 706.544 411.414V267.586C706.545 266.727 706.377 265.877 706.05 265.084C705.723 264.29 705.243 263.569 704.638 262.962C704.033 262.355 703.315 261.873 702.524 261.545C701.734 261.217 700.887 261.048 700.032 261.048Z"
									fill="white"
									fill-opacity="0.15"
								/>
								<path
									d="M753.319 490.186C754.175 490.187 755.022 490.018 755.812 489.689C756.602 489.359 757.321 488.877 757.926 488.268C758.53 487.66 759.01 486.938 759.337 486.142C759.664 485.347 759.833 484.495 759.832 483.635V195.365C759.832 193.628 759.146 191.961 757.924 190.733C756.703 189.504 755.046 188.814 753.319 188.814C751.592 188.814 749.935 189.504 748.714 190.733C747.492 191.961 746.806 193.628 746.806 195.365V483.635C746.806 484.495 746.974 485.347 747.301 486.142C747.628 486.938 748.108 487.66 748.713 488.268C749.318 488.877 750.036 489.359 750.826 489.689C751.617 490.018 752.464 490.187 753.319 490.186Z"
									fill="white"
									fill-opacity="0.15"
								/>
								<path
									d="M806.903 417.952C807.798 417.952 808.683 417.783 809.51 417.455C810.336 417.127 811.087 416.645 811.719 416.038C812.351 415.431 812.853 414.71 813.195 413.916C813.537 413.123 813.713 412.273 813.712 411.414V267.586C813.712 265.852 812.995 264.189 811.718 262.963C810.441 261.737 808.709 261.048 806.903 261.048C805.097 261.048 803.365 261.737 802.089 262.963C800.812 264.189 800.094 265.852 800.094 267.586V411.414C800.094 412.273 800.269 413.123 800.611 413.916C800.953 414.71 801.455 415.431 802.087 416.038C802.72 416.645 803.471 417.127 804.297 417.455C805.123 417.783 806.009 417.952 806.903 417.952Z"
									fill="white"
									fill-opacity="0.15"
								/>
								<path
									d="M860.487 297.166C859.632 297.165 858.785 297.335 857.994 297.664C857.204 297.993 856.486 298.476 855.881 299.086C855.276 299.695 854.796 300.418 854.469 301.214C854.142 302.01 853.974 302.863 853.974 303.724V375.868C853.974 377.607 854.66 379.275 855.882 380.505C857.103 381.735 858.76 382.426 860.487 382.426C862.214 382.426 863.871 381.735 865.092 380.505C866.314 379.275 867 377.607 867 375.868V303.724C867.001 302.863 866.832 302.01 866.505 301.214C866.178 300.418 865.698 299.695 865.094 299.086C864.489 298.476 863.77 297.993 862.98 297.664C862.19 297.335 861.343 297.165 860.487 297.166Z"
									fill="white"
									fill-opacity="0.15"
								/>
								<path
									d="M593.456 454.069C594.311 454.069 595.158 453.9 595.949 453.572C596.739 453.243 597.457 452.76 598.062 452.152C598.667 451.544 599.147 450.823 599.474 450.028C599.801 449.234 599.969 448.382 599.969 447.522V231.478C599.969 229.742 599.283 228.076 598.061 226.849C596.84 225.621 595.183 224.931 593.456 224.931C591.728 224.931 590.072 225.621 588.85 226.849C587.629 228.076 586.943 229.742 586.943 231.478V447.522C586.942 448.382 587.11 449.234 587.438 450.028C587.765 450.823 588.244 451.544 588.849 452.152C589.454 452.76 590.172 453.243 590.963 453.572C591.753 453.9 592.6 454.069 593.456 454.069Z"
									fill="white"
									fill-opacity="0.15"
								/>
								<path
									d="M539.872 562.421C540.766 562.421 541.651 562.252 542.478 561.923C543.304 561.593 544.055 561.111 544.687 560.502C545.32 559.893 545.821 559.17 546.163 558.374C546.505 557.578 546.681 556.725 546.681 555.864V123.136C546.681 121.397 545.963 119.729 544.686 118.499C543.409 117.27 541.677 116.579 539.872 116.579C538.066 116.579 536.334 117.27 535.057 118.499C533.78 119.729 533.063 121.397 533.063 123.136V555.864C533.062 556.725 533.238 557.578 533.58 558.374C533.922 559.17 534.423 559.893 535.056 560.502C535.688 561.111 536.439 561.593 537.265 561.923C538.092 562.252 538.977 562.421 539.872 562.421Z"
									fill="white"
									fill-opacity="0.15"
								/>
								<path
									d="M486.288 454.069C487.143 454.069 487.99 453.9 488.781 453.572C489.571 453.243 490.289 452.76 490.894 452.152C491.499 451.544 491.979 450.823 492.306 450.028C492.633 449.234 492.801 448.382 492.801 447.522V231.478C492.801 229.742 492.115 228.076 490.893 226.849C489.672 225.621 488.015 224.931 486.288 224.931C484.561 224.931 482.904 225.621 481.683 226.849C480.461 228.076 479.775 229.742 479.775 231.478V447.522C479.774 448.382 479.943 449.234 480.27 450.028C480.597 450.823 481.077 451.544 481.681 452.152C482.286 452.76 483.004 453.243 483.795 453.572C484.585 453.9 485.432 454.069 486.288 454.069Z"
									fill="white"
									fill-opacity="0.15"
								/>
								<path
									d="M-111.557 165.799H-38.1524C-30.0062 165.799 -23.4024 172.402 -23.4024 180.545C-23.4024 188.689 -30.0062 195.291 -38.1524 195.291H-111.902V224.783H-38.1524C-30.0062 224.783 -23.4024 231.386 -23.4024 239.529C-23.4024 247.673 -30.0062 254.276 -38.1524 254.276H-111.902V283.768H-38.1524C-30.0062 283.768 -23.4024 290.37 -23.4024 298.514C-23.4024 306.657 -30.0062 313.26 -38.1524 313.26H-111.902V342.752H163.431V313.26H89.6809C81.5347 313.26 74.9309 306.657 74.9309 298.514C74.9309 290.37 81.5347 283.768 89.6809 283.768H163.431V254.276H89.6809C81.5347 254.276 74.9309 247.673 74.9309 239.529C74.9309 231.386 81.5347 224.783 89.6809 224.783H163.431V195.291H89.6809C81.5347 195.291 74.9309 188.689 74.9309 180.545C74.9309 172.402 81.5347 165.799 89.6809 165.799H163.085C158.043 94.3764 98.4891 38 25.7643 38C-46.9606 38 -106.515 94.3764 -111.557 165.799Z"
									fill="white"
									fill-opacity="0.75"
								/>
								<path
									d="M-111.902 372.244V391.905C-111.902 467.916 -50.2669 529.535 25.7643 529.535C101.795 529.535 163.431 467.916 163.431 391.905V372.244H-111.902Z"
									fill="white"
									fill-opacity="0.75"
								/>
								<path
									d="M-160.102 379.415C-153.201 379.808 -147.927 385.72 -148.32 392.619C-149.977 421.641 -143.17 465.362 -117.792 501.45C-92.9122 536.829 -49.3093 566.178 25.7643 566.178C100.838 566.178 144.441 536.829 169.321 501.45C194.698 465.362 201.505 421.641 199.849 392.619C199.455 385.72 204.73 379.808 211.631 379.415C218.531 379.021 224.445 384.294 224.838 391.193C226.736 424.432 219.149 474.102 189.797 515.842C161.482 556.105 113.72 587.791 38.2797 590.943V693.976H13.2493V590.943C-62.1909 587.791 -109.954 556.105 -138.269 515.842C-167.621 474.102 -175.207 424.432 -173.31 391.193C-172.916 384.294 -167.003 379.021 -160.102 379.415Z"
									fill="white"
									fill-opacity="0.75"
								/>
								<path
									d="M-36.8116 706.488C-36.8116 699.578 -31.2084 693.976 -24.2964 693.976H75.8247C82.7367 693.976 88.3399 699.578 88.3399 706.488C88.3399 713.398 82.7367 719 75.8247 719H-24.2964C-31.2084 719 -36.8116 713.398 -36.8116 706.488Z"
									fill="white"
									fill-opacity="0.75"
								/>
								<path
									d="M-477.087 165.992C-482.411 159.828 -491.726 159.147 -497.891 164.47C-521.144 184.547 -562 246.531 -562 345.433C-562 444.11 -521.384 527.362 -500.364 557.61C-495.716 564.299 -486.524 565.954 -479.834 561.307C-473.144 556.661 -471.489 547.472 -476.136 540.783C-494.45 514.43 -532.5 436.936 -532.5 345.433C-532.5 254.156 -494.69 200.674 -478.609 186.79C-472.444 181.467 -471.762 172.155 -477.087 165.992Z"
									fill="white"
									fill-opacity="0.75"
								/>
								<path
									d="M553.891 164.47C547.726 159.147 538.411 159.828 533.087 165.992C527.762 172.155 528.444 181.467 534.609 186.79C550.689 200.674 588.5 254.156 588.5 345.433C588.5 436.936 550.45 514.43 532.136 540.783C527.489 547.472 529.144 556.661 535.834 561.307C542.524 565.954 551.716 564.299 556.363 557.61C577.383 527.362 618 444.11 618 345.433C618 246.531 577.144 184.547 553.891 164.47Z"
									fill="white"
									fill-opacity="0.75"
								/>
								<path
									d="M-400.101 214.117C-394.209 208.494 -384.872 208.711 -379.247 214.602C-373.622 220.493 -373.84 229.827 -379.732 235.45C-389.455 244.729 -414.5 283.163 -414.5 349.902C-414.5 416.743 -389.32 473.283 -377.429 492.196C-373.094 499.091 -375.17 508.194 -382.067 512.528C-388.964 516.862 -398.069 514.786 -402.405 507.891C-416.736 485.097 -444 423.192 -444 349.902C-444 276.508 -416.6 229.862 -400.101 214.117Z"
									fill="white"
									fill-opacity="0.75"
								/>
								<path
									d="M456.101 214.117C450.208 208.494 440.872 208.711 435.247 214.602C429.622 220.493 429.839 229.827 435.732 235.45C445.455 244.729 470.5 283.163 470.5 349.902C470.5 416.743 445.32 473.283 433.429 492.196C429.094 499.091 431.17 508.194 438.067 512.528C444.964 516.862 454.069 514.786 458.404 507.891C472.736 485.097 500 423.192 500 349.902C500 276.508 472.6 229.862 456.101 214.117Z"
									fill="white"
									fill-opacity="0.75"
								/>
								<path
									d="M-301.182 243.08C-294.997 237.78 -285.686 238.496 -280.384 244.679C-275.083 250.863 -275.799 260.172 -281.984 265.472C-289.858 272.219 -311.25 301.382 -311.25 352.583C-311.25 404.019 -289.609 447.657 -279.5 462.095C-274.828 468.767 -276.451 477.961 -283.125 482.632C-289.798 487.302 -298.995 485.679 -303.667 479.008C-316.502 460.677 -340.75 411.25 -340.75 352.583C-340.75 293.68 -316.253 255.994 -301.182 243.08Z"
									fill="white"
									fill-opacity="0.75"
								/>
								<path
									d="M336.384 244.679C341.686 238.496 350.998 237.78 357.183 243.08C372.254 255.994 396.75 293.68 396.75 352.583C396.75 411.25 372.502 460.677 359.667 479.008C354.996 485.679 345.799 487.302 339.125 482.632C332.451 477.961 330.828 468.767 335.5 462.095C345.609 447.657 367.25 404.019 367.25 352.583C367.25 301.382 345.858 272.219 337.984 265.472C331.799 260.172 331.083 250.863 336.384 244.679Z"
									fill="white"
									fill-opacity="0.75"
								/>
							</g>
							<defs>
								<radialGradient
									id="paint0_radial"
									cx="0"
									cy="0"
									r="1"
									gradientUnits="userSpaceOnUse"
									gradientTransform="translate(207 339) scale(660 843.55)"
								>
									<stop stop-color="#2DB2BC" />
									<stop offset="1" stop-color="#014656" />
								</radialGradient>
							</defs>
						</svg>
						<div class="audio-file-block">
							<audio
								#audioTag
								class="audioCreative"
								[src]="creative.audioURL"
								[controls]="'controls'"
								[muted]="'muted'"
								[controlsList]="'nodownload'"
							></audio>
						</div>
					</div>
				</div>
			</div>
			<div *ngIf="creative.isSocial" class="creative-video-social">
				<div class="creative-name-arrows-div creative-name-arrows-div-video">
					<div class="leftRs cursorPointer" [ngClass]="{ arrows_disabled: creativesNum.length == 1 }">
						<img src="../../../../../assets/creative-assets/arrow-left-r7.svg" (click)="navigateLeft()" />
					</div>
					<div>
						<h5 class="ellipse creative-card-name" [title]="creative?.creativeName">
							{{ creative?.creativeName }}
						</h5>
					</div>
					<div class="rightRs cursorPointer" [ngClass]="{ arrows_disabled: creativesNum == 1 }">
						<img src="../../../../../assets/creative-assets/arrow-right-r7.svg" (click)="navigateRight()" />
					</div>
				</div>
				<div
					*ngIf="creative?.creativeThumbnail"
					class="social-thumbnail"
					(click)="openModal()"
					[ngStyle]="{
						background: 'url(' + creative?.creativeThumbnail + ') no-repeat center center / contain',
						'background-size': getCreativeSize(creative.creativeThumbnail)
					}"
				></div>
				<div
					*ngIf="creative?.snapshotImage && creative.isIframeExpired === 1 && !creative?.creativeThumbnail"
					class="social-thumbnail"
					(click)="openModal()"
					[ngStyle]="{
						background: 'url(' + creative?.snapshotImage + ') no-repeat center center / contain',
						'background-size': getCreativeSize(creative.creativeThumbnail)
					}"
				></div>
				<div
					*ngIf="!creative?.snapshotImage && !creative?.creativeThumbnail"
					class="social-thumbnail"
					[ngStyle]="{
						background:
							'url(../../../../../../assets/images/iframe_ad_not_available.png) no-repeat center center / contain',
						'background-size': getCreativeSize(creative.creativeThumbnail)
					}"
				></div>
				<!-- <div *ngIf="creative.isIframeExpired == 0" class="social-thumbnail" [innerHtml]="iFrameUrl"></div> -->
			</div>
			<div class="sem-creative-card-container sem-creative-performance-card" *ngIf="creative.adHeadline || creative.description">
				<div class="creative-name-arrows-div creative-name-arrows-div-video">
					<div class="leftRs cursorPointer" [ngClass]="{ arrows_disabled: creativesNum == 1 }">
						<img src="../../../../../assets/creative-assets/arrow-left-r7.svg" (click)="navigateLeft()" />
					</div>
					<div>
						<h5 class="ellipse creative-card-name" [title]="creative?.adHeadline">{{ creative?.adHeadline }}</h5>
					</div>
					<div class="rightRs cursorPointer" [ngClass]="{ arrows_disabled: creativesNum == 1 }">
						<img src="../../../../../assets/creative-assets/arrow-right-r7.svg" (click)="navigateRight()" />
					</div>
				</div>
				<div class="sem-creative-card">
					<div class="sem-creative-card-scroll">
						<h4 class="sem-creative-heading">{{ creative.adHeadline }}</h4>
						<div class="sem-creative-card-link-container">
							<span class="sem-creative-card-text">AD</span>
							<cite class="sem-creative-card-link">{{ creative.url }}</cite>
						</div>
						<span class="sem-creative-card-roboto"> {{ creative.callExtension }}</span>
						<div
							*ngIf="isTypeString(creative?.description); else elseBlock"
							class="sem-creative-card-description sem-creative-card-roboto"
						>
							{{ creative?.description }}
						</div>
						<ng-template #elseBlock>
							<div class="sem-creative-card-description sem-creative-card-roboto">
								<p *ngFor="let desc of creative?.description">
									{{ desc }}
								</p>
							</div>
						</ng-template>
						<div class="sem-creative-card-callouts-container sem-creative-card-roboto">
							<div>
								<p>
									<span *ngFor="let callout of creative?.calloutsExtn; let i = index"
										>{{ callout
										}}<span [ngClass]="{ last_callout_class: i == creative?.calloutsExtn.length - 1 }">
											&middot;
										</span></span
									>
								</p>
							</div>
						</div>
						<div class="sem-creative-card-structuredsnippets-container sem-creative-card-roboto">
							<div *ngFor="let snippet of creative?.structuredSnippetExtn">
								<p>{{ snippet?.type }}: {{ snippet?.value }}</p>
							</div>
						</div>
						<div class="sem-creative-card-siteLinks-container">
							<div *ngFor="let siteLink of creative.siteLinks" class="sem-creative-card-sitelinks">
								<h4>
									<a href="{{ siteLink.link }}" target="_blank">{{ siteLink.heading }}</a>
								</h4>
								<span class="sem-creative-card-roboto">{{ siteLink.description }}</span>
							</div>
						</div>
						<div *ngIf="creative?.location">
							<span class="sem-creative-card-location"
								><i class="fa fa-map-marker" aria-hidden="true" style="color: #575757"></i>
								{{ creative.location }}</span
							>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div
			class="stats-parent-div"
			[ngClass]="{
				'stats-parent-div-2': creative.adHeadline || creative.isVideoCreative,
				'social-stats': creative.isSocial
			}"
			*ngIf="showStats"
		>
			<div *ngIf="creative">
				<div class="{{ firstSectionClass }}_statsHeight">
					<div
						class="p-1"
						[ngClass]="{ 'p-2': creative.isVideoCreative, 'p-3': creative.adHeadline }"
						*ngFor="let metric of metricsArray"
					>
						<div class="inline textLeft">
							<div class="stats primary-color" *ngIf="!metric.showPercent">{{ creative[metric?.value] | number }}</div>
							<div class="stats primary-color" *ngIf="metric.showPercent">
								{{ creative[metric?.value] | number : '0.2-2' }}%
							</div>
							<span class="stats-label">{{ metric.displayName }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="clear"></div>
	</div>
	<div class="clear"></div>
</div>
